import { authService } from './authService';

/**
 * A/B do Welcome: o Welcome dedicado sorteia (e grava) para qual lado cada conta nova vai.
 * O percentual é controlado no Dashboard (/admin/welcome-ab), sem deploy.
 *
 * Fail-closed: sem resposta em 1,5s — ou qualquer erro — a conta fica no assistente daqui, e
 * nele permanece.
 */
export const LIMITE_DO_SORTEIO_MS = 1500;

const welcomeUrl = () => import.meta.env.VITE_WELCOME_URL?.replace(/\/+$/, '');

/** @returns {Promise<'novo' | 'antigo'>} */
export async function perguntarLadoDoWelcome() {
  const base = welcomeUrl();
  const token = authService.getToken();
  if (!base || !token) return 'antigo';

  const controle = new AbortController();
  const relogio = setTimeout(() => controle.abort(), LIMITE_DO_SORTEIO_MS);
  try {
    const resposta = await fetch(`${base}/sorteio`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` },
      signal: controle.signal,
    });
    if (!resposta.ok) return 'antigo';
    const corpo = await resposta.json();
    return corpo?.lado === 'novo' ? 'novo' : 'antigo';
  } catch {
    return 'antigo';
  } finally {
    clearTimeout(relogio);
  }
}

// Quem viu o assistente daqui continua nele neste navegador — mesmo que o Welcome responda
// "novo" numa visita seguinte (porque demorou demais na primeira, ou porque o 0% foi desfeito).
const chaveDoAntigo = () => {
  const userId = authService.getUserInfo()?.userId;
  return userId ? `agendario_welcome_ab_antigo_${userId}` : null;
};

export function ficouNoAntigo() {
  try {
    const chave = chaveDoAntigo();
    return chave !== null && localStorage.getItem(chave) === '1';
  } catch {
    return false;
  }
}

export function lembrarQueFicouNoAntigo() {
  try {
    const chave = chaveDoAntigo();
    if (chave) localStorage.setItem(chave, '1');
  } catch {
    // sem localStorage, a próxima visita pergunta de novo
  }
}

export function urlDeEntradaNoWelcome() {
  return `${welcomeUrl()}/entrar?token=${encodeURIComponent(authService.getToken() ?? '')}`;
}
